export default __webpack_public_path__ + "static/media/ic_create_password.cf848fa9.png";